import React from 'react';
import {
  Email as EmailIcon,
  Webhook as WebhookIcon,
  TableChart as SheetIcon,
  Forum as SlackIcon,
  Groups as TeamsIcon,
  Reply as ReplyIcon,
  Event as CalendarIcon,
  Extension as ExtensionIcon,
} from '@mui/icons-material';

/**
 * One icon per delivery channel, shared by the destinations dialog and the flows list so a
 * connector looks the same wherever it is named.
 *
 * <p>A type with no icon here still renders: the backend's connector registry is the list that
 * matters, and a channel this build's icon map has not caught up with gets the generic plug
 * rather than a hole in the row.
 */
const TYPE_ICONS = {
  EMAIL: EmailIcon,
  WEBHOOK: WebhookIcon,
  GOOGLE_SHEETS: SheetIcon,
  SLACK: SlackIcon,
  TEAMS: TeamsIcon,
  WHATSAPP_REPLY: ReplyIcon,
  GOOGLE_CALENDAR: CalendarIcon,
};

/** The icon component for a destination type, never null. */
export const iconComponentFor = (type) => TYPE_ICONS[type] || ExtensionIcon;

/** A rendered small icon, the form both call sites want. */
export const iconFor = (type) => {
  const Icon = iconComponentFor(type);
  return <Icon fontSize="small" />;
};
